'use client';

import { SuccessLottie } from '@/components/success-lottie';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { useState } from 'react';
interface RedeemDialogProps {
  open: boolean;
  isSuccess: boolean;
  onOpenChange: (open: boolean) => void;
  availableBalance: number;
  transferDestination: {
    type: 'bank' | 'upi';
    details: string;
    maskedId: string;
  } | null;
  onRedeem: (amount: number) => void;
  errorMessage?: string | null;
}
export default function RedeemDialog({
  open,
  isSuccess,
  onOpenChange,
  availableBalance,
  transferDestination,
  onRedeem,
  errorMessage
}: RedeemDialogProps) {
  const [amount, setAmount] = useState<string>('');
  const handleRedeem = () => {
    const numberAmount = Number.parseFloat(amount);
    if (numberAmount && numberAmount <= availableBalance) {
      onRedeem(numberAmount);
    }
  };
  return <Dialog open={open} onOpenChange={onOpenChange} data-sentry-element="Dialog" data-sentry-component="RedeemDialog" data-sentry-source-file="redeem-amount-dialog.tsx">
      <DialogContent className="w-80 p-0 md:w-full md:max-w-[400px] [&>button:first-child]:hidden" data-sentry-element="DialogContent" data-sentry-source-file="redeem-amount-dialog.tsx">
        <DialogHeader className="p-6 pb-0" data-sentry-element="DialogHeader" data-sentry-source-file="redeem-amount-dialog.tsx">
          <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="redeem-amount-dialog.tsx">Redeem</DialogTitle>
        </DialogHeader>
        {isSuccess ? <div className="flex flex-col items-center justify-center p-6 pt-0 text-center md:min-w-[400px]">
                <SuccessLottie />
                <div className=" top-3/4 space-y-2">
                  <div className="text-4xl font-medium">
                    ₹
                    {Number.parseFloat(amount).toLocaleString()}
                  </div>
                  <div className="text-xl">Sent Successfully</div>
                  <div className="rounded bg-[#F4F8FE] py-2 text-sm ">
                    {transferDestination?.details}
                    <br />
                    xxxx xxxx
                    {' '}
                    {transferDestination?.maskedId}
                  </div>
                </div>
              </div> : <div className=" max-w-80 space-y-6 p-6 md:max-w-[400px]">
                <div className="space-y-4">
                  <div className="relative flex max-w-full items-center justify-center">
                    <div className="pl-6 text-xl font-medium">
                      ₹
                    </div>
                    <Input type="number" value={amount} onChange={event => setAmount(event.target.value)} className="size-auto min-w-[50px] max-w-full border-0 px-0 py-3 text-center !text-4xl font-medium shadow-none outline-none [appearance:textfield] placeholder:text-4xl focus-visible:ring-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none" placeholder="0" max={availableBalance} style={{
              width: `${Math.max(50, amount.length * 25)}px`
            }} />

                  </div>

                  <div className="text-center text-sm text-muted-foreground">
                    Available balance: ₹
                    {availableBalance.toLocaleString()}
                  </div>
                  {errorMessage && <div className=" text-center text-sm text-red-500">
                      {errorMessage}
                    </div>}
                </div>

                <div className="space-y-2 rounded-lg bg-[#F4F8FE] p-4 text-center">
                  <div className="text-sm text-muted-foreground">
                    Amount will be transferred to
                  </div>
                  <div className="font-medium">
                    {transferDestination?.type === 'bank' ? <>
                            {transferDestination.details}
                            <div className="text-sm text-muted-foreground">
                              xxxx xxxx
                              {' '}
                              {transferDestination.maskedId}
                            </div>
                          </> : <>
                            UPI ID:
                            {' '}
                            {transferDestination?.maskedId}
                            <div className="text-sm text-muted-foreground">
                              {transferDestination?.details}
                            </div>
                          </>}
                  </div>
                </div>
                <Button className="w-full rounded-full bg-x-primary-1 hover:bg-x-primary-2" size="lg" onClick={handleRedeem} disabled={!amount || Number.parseFloat(amount) > availableBalance}>
                  Redeem
                </Button>
              </div>}

      </DialogContent>
    </Dialog>;
}